import { z } from 'zod';
import { AdminRoleDetails } from 'store/permissions';
import { adminsFiltersSchema } from './admins.schemas';

export const adminStatuses = ['active', 'inactive'] as const;
export type AdminStatus = (typeof adminStatuses)[number];

export const adminRoles = ['hrAdmin', 'melpAdmin', 'hrProgrammatic'] as const;
export type AdminRole = (typeof adminRoles)[number];

export interface BaseAdmin {
  id: string;
  status: AdminStatus;
  fullName: string;
  email: string;
  phone: string;
  adminRole: AdminRoleDetails | null;
  permissionScopes: Array<{
    id: string;
    name: string;
  }>;
}

export interface Admin extends BaseAdmin {
  firstName: string;
  lastName: string;
  role: AdminRole;
  root: boolean;
  parentCompanyId: string;
  employeeId: string;
  apiKeyAbbreviated: string;
  clientIntegrationId: string;
  integrationType: string | null;
  tokens: Array<{ jti: string; name: string; createdAt: string }>;
}

export type AdminsFilters = z.infer<typeof adminsFiltersSchema>;
